// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Ry5K","selected":"Chip_selected__2yGY1"};